<template>
  <div class="form-group">
    <label :for="name">{{ label }}</label>
    <input
      type="file"
      :id="name"
      @change="processFile($event)"
      accept="image/*"
      :multiple="multiple"
    />
    <div class="row image-preview">
      <div
        class="col-2 my-2"
        v-for="(image, index) in images"
        v-if="multiple || (!multiple && uploadImages.length === 0)"
        :key="index"
      >
        <div class="img-thumbnail text-center">
          <img width="100%" :src="image.image_url" class="thumbnail" alt="" />
          <a class="remove-icon" @click="() => removeImage(index)">
            <em class="fa fa-remove" />
          </a>
        </div>
      </div>
      <div
        class="col-2 my-2"
        v-for="(image, index) in uploadImages"
        :key="index"
      >
        <div class="img-thumbnail text-center loading-thumbnail">
          <img width="100%" :src="image" class="thumbnail preview" alt="" />
          <div class="overlay"></div>
          <div class="loading">
            <em class="fa fa-2x fa-spin fa-spinner loading-icon" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImagePicker',
  props: {
    name: String,
    label: String,
    images: {
      type: Array,
      default: () => [],
    },
    multiple: Boolean,
  },
  methods: {
    ...mapActions({
      uploadImage: 'global/uploadImage',
    }),
    removeImage(key) {
      const newImages = this.images.filter((image, index) => index !== key);
      this.$emit('change', newImages);
    },
    processFile(event) {
      const files = [];
      const uploadFiles = event.target.files;

      for (let i = 0; i < uploadFiles.length; i++) {
        files[i] = uploadFiles[i];
      }

      this.uploadImages = files.map(file => URL.createObjectURL(file));
      const promises = files.map(file => this.uploadImage(file));

      Promise.all(promises)
        .then((uploadedImages) => {
          const currentImages = this.images;
          this.$emit(
            'change',
            this.multiple ? currentImages.concat(uploadedImages) : uploadedImages,
          );
          this.uploadImages = [];
        });
    },
  },
  data() {
    return {
      uploadImages: [],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.thumbnail {
  height: 120px;
  max-width: 100%;
  object-fit: contain;
}

.loading-thumbnail {
  position: relative;
}

.overlay {
  width: 100%;
  height: 100%;
  position: absolute;
  background: #000;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 1;
}

.loading {
  width: 100%;
  height: 100%;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  left: 0;
  top: 0;
}

.loading-icon {
  color: #FFF;
}

.remove-icon .fa {
  padding: 7px;
  border-radius: 100%;
  color: #FFF;
  background: #000;
  position: absolute;
  top: -5px;
  right: 0;
  cursor: pointer;
}

</style>
